import { Layout, Grid } from 'antd';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';

const { Content } = Layout;
const { useBreakpoint } = Grid;

export function AppLayout() {
  const screens = useBreakpoint();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      <Content
        role="main"
        style={{
          padding: screens.md ? 24 : screens.sm ? 16 : 12,
          background: '#f0f2f5',
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
}
